import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Platforms } from '../enums/util.enum';
declare const cordova: any;

@Injectable({
  providedIn: 'root'
})
export class SquarePayService {
  public isCanUseApplePay:boolean = false;
  public isCanUseGooglePay:boolean = false;

  constructor(
    private platform: Platform,
  ) { }

  public async checkCanUseWalletPay() {
    if(this.platform.is("cordova")){
      try {
        if(this.platform.is(Platforms.IOS)){
          let result = await this.canUseApplePay();
          this.isCanUseApplePay = result;
        } else if(this.platform.is(Platforms.ANDROID)){
          let result = await this.canUseGooglePay();
          this.isCanUseGooglePay = result;
        }
       }catch(err){
        console.error(err)
       }
    }
  }

  public async canUseApplePay():Promise<boolean> {
   return new Promise((resolve,reject) => {
    try{
      cordova.plugins.SquarePayPlugin.canUseApplePay((res)=>{
          resolve(true)
       },function(error) {
         console.error(error)
         reject(false)
       })
    }catch(error){
      console.error(error)
      reject(false)
    }
   })
  }

  public async canUseGooglePay():Promise<boolean> {
    return new Promise((resolve,reject) => {
      try{
        cordova.plugins.SquarePayPlugin.canUseGooglePay((res)=>{
          resolve(true)
         },function(error) {
           console.error(error)
           reject(false)
         })
      }catch(error){
        console.error(error)
        reject(false)
      }
     })
  }

  public async nativeApplePay(paymentRequest:any):Promise<any> {
    return new Promise((resolve,reject)=>{
      try {
        cordova.plugins.SquarePayPlugin.requestApplePayAuthorization(paymentRequest)
        .then((response)=>resolve(response))
        .catch((error)=>reject(error));
      }catch(error){
        console.error(error)
        reject(error)
      }
    })
  }

  public async nativeGooglePay(paymentRequest:any,locationId:string):Promise<any> {
    return new Promise((resolve,reject)=>{
      try {
        cordova.plugins.SquarePayPlugin.requestGooglePayAuthorization(paymentRequest,locationId)
        .then((response)=>resolve(response))
        .catch((error)=>reject(error));
      }catch(error){
        console.error(error)
        reject(error)
      }
    })
  }
}
